import { default as _91id_93WRRcG6VGBMMeta } from "/var/www/html/collection-experience/frontend/pages/[locale]/[id].vue?macro=true";
import { default as cookie_45policyjpvmBiCGFgMeta } from "/var/www/html/collection-experience/frontend/pages/[locale]/cookie-policy.vue?macro=true";
import { default as indextbDYt7trrHMeta } from "/var/www/html/collection-experience/frontend/pages/[locale]/index.vue?macro=true";
import { default as privacy_45policyuCAtzAWInBMeta } from "/var/www/html/collection-experience/frontend/pages/[locale]/privacy-policy.vue?macro=true";
export default [
  {
    name: "locale-id",
    path: "/:locale()/:id()",
    component: () => import("/var/www/html/collection-experience/frontend/pages/[locale]/[id].vue")
  },
  {
    name: "locale-cookie-policy",
    path: "/:locale()/cookie-policy",
    component: () => import("/var/www/html/collection-experience/frontend/pages/[locale]/cookie-policy.vue")
  },
  {
    name: "locale",
    path: "/:locale()",
    component: () => import("/var/www/html/collection-experience/frontend/pages/[locale]/index.vue")
  },
  {
    name: "locale-privacy-policy",
    path: "/:locale()/privacy-policy",
    component: () => import("/var/www/html/collection-experience/frontend/pages/[locale]/privacy-policy.vue")
  }
]